import React from 'react'
import { useTranslate } from '@tolgee/react'

interface SkeletonProps {
  primaryColor: string
  secondaryColor: string
  animate: boolean

  [key: string]: boolean | string | number
}

const Skeleton = ({
  primaryColor = '#BBBBBB',
  secondaryColor,
  animate,
  ...props
}: SkeletonProps): JSX.Element => {
  const { t } = useTranslate()
  return (
    <svg viewBox="0 0 380 130" preserveAspectRatio="none" {...props}>
      <title>{t('ProductCardSkeleton')}</title>
      <path
        clipPath="url(#prefix__pzv63v87r5a)"
        fill="url(#prefix__mfzffledi8p)"
        d="M0 0h380v130H0z"
      />
      <defs>
        <clipPath id="prefix__pzv63v87r5a">
          <rect x={70} y={15} rx={4} ry={4} width={117} height={6} />
          <rect x={70} y={35} rx={3} ry={3} width={85} height={6} />
          <rect y={80} rx={3} ry={3} width={350} height={6} />
          <rect y={100} rx={3} ry={3} width={380} height={6} />
          <rect y={120} rx={3} ry={3} width={201} height={6} />
          <path d="M0 0h50v50H0z" />
        </clipPath>
        <linearGradient id="prefix__mfzffledi8p">
          <stop offset={0.81} stopColor={primaryColor}>
            {animate && (
              <animate
                attributeName="offset"
                values="-2; -2; 1"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            )}
          </stop>
          <stop offset={1.81} stopColor={secondaryColor}>
            {animate && (
              <animate
                attributeName="offset"
                values="-1; -1; 2"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            )}
          </stop>
          <stop offset={2.81} stopColor={primaryColor}>
            {animate && (
              <animate
                attributeName="offset"
                values="0; 0; 3"
                keyTimes="0; 0.25; 1"
                dur="2s"
                repeatCount="indefinite"
              />
            )}
          </stop>
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Skeleton
